import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout, { Section, PageHero } from "@/components/layout/Layout";
import { Reveal } from "@/components/common/Reveal";

// Images and slugs are keyed by position (order matches translation array).
const media = [
    { slug: "finance",       img: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80" },
    { slug: "healthcare",    img: "https://images.unsplash.com/photo-1580281657527-47f249e8f4df?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80" },
    { slug: "media",         img: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80" },
    { slug: "retail",        img: "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80" },
    { slug: "public-sector", img: "https://images.unsplash.com/photo-1523731407965-2430cd12f5e4?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80" },
    { slug: "manufacturing", img: "https://images.unsplash.com/photo-1565043666747-69f6646db940?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80" },
    { slug: "education",     img: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80" },
    { slug: "telecom",       img: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80" },
];

export default function Industries() {
    const { t } = useTranslation();
    const items = t("body.industries.items", { returnObjects: true }) || [];
    const ctaCaseStudies = t("body.industries.ctaCaseStudies");
    return (
        <Layout title="Industries — Ventara" description="Trusted where quiet matters most: finance, healthcare, media, retail, and beyond.">
            <PageHero i18nKey="industries"
                eyebrow="Industries"
                title={<>Trusted where<br />quiet matters most.</>}
                lead="We work across sectors where reliability is not decoration but requirement — where a small increase in composure is the whole product."
            />

            <Section className="pb-32">
                <div className="grid md:grid-cols-2 gap-x-8 gap-y-16">
                    {items.map((i, idx) => {
                        const m = media[idx] || {};
                        return (
                            <Reveal key={m.slug || idx} delay={(idx % 2) * 0.08}>
                                <article className="group" data-testid={`industry-card-${m.slug}`}>
                                    <div className="overflow-hidden rounded-3xl aspect-[5/3] bg-muted">
                                        <img src={m.img} alt={i.name} loading="lazy"
                                             className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105 grayscale-[30%] group-hover:grayscale-0" />
                                    </div>
                                    <div className="mt-6 flex items-start justify-between">
                                        <div>
                                            <p className="label">0{idx + 1}</p>
                                            <h3 className="font-serif text-3xl mt-2 tracking-tight">{i.name}</h3>
                                            <p className="prose-body text-sm mt-3 max-w-md">{i.note}</p>
                                            <Link to={`/industries/${m.slug}`} className="mt-4 inline-block text-sm text-muted-foreground hover:text-foreground border-b border-transparent hover:border-foreground/40 transition-colors">
                                                {ctaCaseStudies}
                                            </Link>
                                        </div>
                                    </div>
                                </article>
                            </Reveal>
                        );
                    })}
                </div>
            </Section>
        </Layout>
    );
}
